import { useQuery, useMutation } from "@apollo/client";
import { ApplicantProfileIdentityEdit } from "./applicant-profile-identity-edit";
import {
  StaffApplicantProfileIdentityContainerDocument,
  ApplicantUserPersonalInformation,
  StaffApplicantProfileIdentityUpdateDocument,
} from "../../../../generated";
import { Empty, message, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";

interface ApplicantProfileIdentityEditContainerProps {
  applicantId: string;
};

export const ApplicantProfileIdentityEditContainer: React.FC<ApplicantProfileIdentityEditContainerProps> = ({applicantId}) => {
  const navigate = useNavigate();
  const {
    data,
    loading,
    error,
  } = useQuery(StaffApplicantProfileIdentityContainerDocument, {
    variables: {
      applicantUserId: applicantId,
    },
  });

  const [applicantUserUpdate] = useMutation(
    StaffApplicantProfileIdentityUpdateDocument,
    {
      refetchQueries: [
        {
          query: StaffApplicantProfileIdentityContainerDocument,
          variables: {
            applicantUserId: applicantId,
          },
        },
      ],
      awaitRefetchQueries: true,
    }
  );

  const handleSave = async (data: ApplicantUserPersonalInformation) => {
    try {
      const result = await applicantUserUpdate({
        variables: {
          input: {
            id: applicantId,
            applicantUserDetails: {
              personalInformation: {
                ...data
              },
            },
          },
        },
      });
      if (result.data?.applicantUserUpdate.status.success) {
        message.success("Identity details updated");
        handleEdit();
      } else {
        message.error("Failed to update Identity details");
      }
    } catch (error) {
      message.error(`Error updating Identity: ${JSON.stringify(error)}`);
    }
  };

  const handleEdit = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/view");
    navigate(newPath);
  };

  if(error) {
    return <Empty description="Error loading data" />;
  }

  if (loading) {
    return <Skeleton active />;
  }

  return (<ComponentQueryLoader
    error={error}
    loading={loading}
    hasData={data?.applicantUser?.personalInformation !== undefined}
    hasDataComponent={
      <ApplicantProfileIdentityEdit
      personalInformation={
          data?.applicantUser?.personalInformation as ApplicantUserPersonalInformation
        }
        onCancel={handleEdit}   
        onSave={handleSave}
      />
    }
  />);
};
